import React from "react";
import UserPosts from "../Posts/UserPosts";
import Header from "../Header";
import Footer from "../Footer";
import DashboardSideBar from "./DashboardSideBar";
import { NavLink, useLocation } from "react-router-dom";

const Dashboard = () => {
  const location = useLocation();
  return (
    <>
      <Header />
      <div className="below-header">
        <p>
          <NavLink to={"/"}>Home</NavLink>
          <span>/</span>
          <a href={location.pathname} className="aCustom">My Posts</a>
        </p>
      </div>
      <div className="flex-screen custom_section">
        <DashboardSideBar />
        <UserPosts />
      </div>
      <Footer />
    </>
  );
};

export default Dashboard;
